<template>
<div class="back-button-holder" :class="'back-'+currentPostType">
    <router-link :to="link" class="back-btn uppercase" :aria-label="text">
        <span class="icon" v-html="arrowIcon"></span>
        <span>{{text}}</span>
    </router-link>
</div>
</template>

<script>

import { mapGetters } from 'vuex';
import { arrow } from '@/components/../icons';

export default {
    name: 'header-back-button',
    props: {
        
    },
    data(){
        return {
            link : '/',
            text: 'Siden ovenfor'
        }
    },
    mounted(){
        if(this.isArchive){
                this.text = 'Forsiden'
                this.link = '/'
        }else switch (this.currentPostType) {
            case 'page':
                this.text = (this.currentPage.parent) ? 'Siden ovenfor' : 'Forsiden'
                this.link = (this.currentPage.parent) ? this.currentPage.link.replace(this.currentPage.slug, "").replace(/\/$/, "").replace(window.WPVUE.home.replace(/\/$/, ""), "") : '/'
                break;
            case 'post':
                this.text = 'Aktuelt'
                this.link = '/'+window.WPVUE.blog_base.slug
                break;
            case 'professions':
                this.text = 'Yrker'
                this.link = '/'+window.WPVUE.options.archive_professions.slug
                break;
            case 'educations':
                this.text = 'Utdanninger'
                this.link = '/'+window.WPVUE.options.archive_educations.slug
                break;
            case 'ambassadors':
                this.text = 'Ambassadører'
                this.link = '/'+window.WPVUE.options.archive_ambassadors.slug
                break; 
            case 'teachers':
                this.text = 'Rådgivere og lærere'
                this.link = '/'+window.WPVUE.options.archive_teachers.slug
                break;
        }
    },
    computed:{
        ...mapGetters([
            'currentPostType',
            'currentPage',
            'isArchive'
        ]),
        arrowIcon(){
            return arrow('#FFF')
        }
    },
    
};
</script>


<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.back-button-holder{
    text-align: center;
    margin-bottom: 15px;
    .back-btn{
        display: inline-block;
        border: none;
        box-shadow: none;
        text-decoration: none;
        color: #fff;
        align-items: center;
        text-transform: uppercase;
        background-color: transparent;
        @include fluid-type($smallResText, $wideResText, 12px, 14px);
        margin: 0 auto;
        font-weight: 700;
        .icon{
            margin-right: 15px;
        }
    }
}
</style>